import { Avatar, Skeleton } from "@mui/material";
import React, { useState, useEffect, useContext } from "react";
import { Link, useParams } from "react-router-dom";
import { AuthContext } from "../../context/AuthContext";
import Localbase from "localbase";
import axios from "axios";
import ENDPOINT from "../../data/ENDPOINT";
import Modal from "@mui/material/Modal";
import ModalStyle from "../../data/ModalStyle";
import { Close } from "@mui/icons-material";
import Box from "@mui/material/Box";
import ConnectionItemSidebarSuggestion from "../connections/ConnectionItemSidebarSuggestion";
import AnimatePage from "../../actions/animations/AnimatePage";
import FetchFingerprint from "../../actions/FetchFingerprint";
import RecommendIcon from "@mui/icons-material/Recommend";

const CommunitySuggestions = ({ account }) => {
  const params = useParams();
  const course_url = params.course_url;

  let db = new Localbase("db");
  const { user } = useContext(AuthContext);
  const [batch, setBatch] = useState(null);
  const [query, setQuery] = useState(null);
  const [fingerprint, setFingerprint] = useState(null);
  const [alert, setalert] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchFingerprint = async () => {
      const fp = await FetchFingerprint();
      setFingerprint(fp);
    };
    fetchFingerprint();
  }, []);

  const Connections = async () => {
    if (!user.SessionId || !fingerprint) return;

    const data = new FormData();
    data.append("session", user.SessionId);
    data.append("fp", fingerprint);
    if (query) {
      data.append("query", query);
    }
    data.append("limit", "5");

    try {
      const res = await axios.post(ENDPOINT + "connections.php", data, {
        headers: { "content-type": "multipart/form-data" },
      });

      if (res.data.status === "success") {
        setBatch(res.data.connections);
        AnimatePage();
      }
    } catch (error) {
      console.error("Error fetching connections:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (fingerprint) {
      Connections();
    }
  }, [fingerprint]);

  return (
    <div className="w-100 section sm-mt-50 community-card">
      {/* Internal CSS – Design Only */}
      <style>{`
        .community-card {
          background: linear-gradient(145deg, #ffffff, #fff4ea);
          border-radius: 18px;
          padding: 16px;
          box-shadow: 0 10px 30px rgba(0,0,0,0.08);
          border: 1px solid rgba(255, 122, 26, 0.35);
        }

        .community-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
        }

        .community-title {
          display: flex;
          align-items: center;
          gap: 6px;
          font-weight: 700;
        }

        .community-title svg {
          color: #ff7a1a;
        }

        .view-all {
          color: #ff7a1a !important;
          font-weight: 600;
          font-size: 14px;
          text-decoration: none;
        }

        .view-all:hover {
          text-decoration: underline;
        }

        .suggestion-row {
          transition: 0.3s ease;
          padding: 10px;
          border-radius: 12px;
          border: 1px solid transparent;
        }

        .suggestion-row:hover {
          background: linear-gradient(90deg, #fff1e6, #ffffff);
          border-left: 3px solid #ff7a1a;
          transform: translateY(-2px);
        }

        .follow-button {
          border: 1.5px solid #ff7a1a;
          color: #ff7a1a;
          background: transparent;
          border-radius: 20px;
          font-size: 12px;
          padding: 6px 14px;
          transition: 0.3s ease;
        }

        .follow-button:hover {
          background: #ff7a1a;
          color: white;
          box-shadow: 0 6px 16px rgba(255, 122, 26, 0.35);
        }

        .suggestion-row h6 {
          font-weight: 600;
          color: #111;
        }

        .suggestion-row p {
          color: #777;
          font-size: 12px;
        }

        @media (max-width: 768px) {
          .community-card {
            padding: 12px;
          }
          .follow-button {
            font-size: 11px;
            padding: 4px 10px;
          }
          .community-title h5 {
            font-size: 15px;
          }
        }
      `}</style>

      <Modal open={alert} onClose={() => setalert(false)}>
        <Box
          sx={ModalStyle}
          className="p-3 br-5 col-11 col-sm-8 col-md-4 col-lg-4"
        >
          <div className="d-flex justify-content-between">
            <h4 className="text-danger">Access Denied !</h4>
            <Close onClick={() => setalert(false)} />
          </div>
          <hr />
          <p>Register a course to connect with friends and learn together.</p>
          <div className="d-flex justify-content-between mt-4">
            <button
              onClick={() => setalert(false)}
              className="btn btn-outline-danger rounded-pill"
            >
              Cancel
            </button>
            <Link to="/courses" className="btn btn-warning rounded-pill">
              Browse Courses
            </Link>
          </div>
        </Box>
      </Modal>

      {batch ? (
        <>
          <div className="community-header">
            <div className="community-title">
              <RecommendIcon />
              <h5 className="m-0">Recommendations</h5>
            </div>
            <Link className="view-all" to="/recommendations">
              View All
            </Link>
          </div>

          <hr className="mt-2 mb-2" />

          {batch.map((user, index) => (
            <>
              {account.purchases !== null && account.purchases.length > 0 ? (
                <ConnectionItemSidebarSuggestion
                  className={"fade-in-bottom delay" + (index + 1) + "s"}
                  connection={user}
                />
              ) : (
                <div
                  key={user.user_id}
                  onClick={() => setalert(true)}
                  className={
                    "d-flex suggestion-row click w-100 justify-content-between align-items-center mt-2 fade-in-bottom delay" +
                    (index + 1) +
                    "s"
                  }
                >
                  <div className="d-flex align-items-center col">
                    <Avatar src={user.profile_pic} />
                    <div className="ms-2">
                      <h6 className="mb-0 truncate truncate1">
                        {user.first_name + " " + user.last_name}
                      </h6>
                      <p className="mb-0 truncate truncate1">
                        @{user.username}
                      </p>
                    </div>
                  </div>

                  <button className="follow-button">Follow</button>
                </div>
              )}
            </>
          ))}
        </>
      ) : (
        <>
          {loading ? (
            <>
              <div className="community-header">
                <h5>Recommendations</h5>
                <Link className="view-all" to="/recommendations">
                  View All
                </Link>
              </div>

              {[1, 2, 3, 4, 5].map((i) => (
                <div key={i} className="d-flex mt-2 w-100">
                  <Avatar />
                  <div className="ms-2 w-100">
                    <Skeleton height={20} className="mb-1 w-100" />
                    <Skeleton height={10} className="w-75" />
                  </div>
                </div>
              ))}
            </>
          ) : (
            <>
              <h4>No Students Found !</h4>
              <p>It seems like no student have joined the community yet.</p>
            </>
          )}
        </>
      )}
    </div>
  );
};

export default CommunitySuggestions;